export default class Search {
    constructor() {
        const search = document.querySelector('[data-behaviour="search"]');
        const modal = document.querySelector('[data-behaviour="search-modal"]');
        search.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.toggle('modal-visible');
            modal.classList.toggle('u-hidden');
        });
        modal.addEventListener('click', (e) => {
            if (
                e.target.classList.contains('modal-mask') ||
                e.target.classList.contains('modal-x-button')
            ) {
                document.body.classList.toggle('modal-visible');
                modal.classList.toggle('u-hidden');
            }
        });
    }
}
